import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Balance from "./components/Balance";
import Form from "./components/Form";
import Layout from "./components/Layout";
import Transactions from "./components/Transactions/Transactions";
import ViewAllTransactions from "./components/Transactions/ViewAllTransaction";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Balance />
              <Form />
              <Transactions />
            </Layout>
          }
        />
        <Route
          path="/view-all"
          element={
            <Layout>
              <ViewAllTransactions />
            </Layout>
          }
        />
         {/* <Route
          path="/view-all"
          element={
 
            <Balance />
            <Form />

          }
        /> */}
      </Routes>
    </Router>
  );
}

export default App;
